import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const productSuggestionsSlider = () => {
  let sliders = document.querySelectorAll('.js-product-suggestions-slider');
  if (sliders.length == 0) return;
  sliders?.forEach((slider) => {
    const arrowLeft = slider.previousElementSibling.querySelector(
      '.js-product-suggestions-sliderArrow--prev',
    );
    const arrowRight = slider.previousElementSibling.querySelector(
      '.js-product-suggestions-sliderArrow--next',
    );
    const swiperOptions = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: false,
      draggable: true,
      navigation: {
        nextEl: arrowRight,
        prevEl: arrowLeft,
      },
      breakpoints: {
        375: {
          slidesPerView: 2.3,
          spaceBetween: 16,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 28,
          slidesOffsetBefore: 64,
          slidesOffsetAfter: 64,
        },
        1536: {
          slidesPerView: 4.4,
          spaceBetween: 32,
          slidesOffsetBefore: 64,
          slidesOffsetAfter: 64,
        },
      },
    };
    new Swiper(slider, swiperOptions);
  });
};
